export const jobDetailsSuffix: Record<string, string> = {
	da: 'job-detaljer',
	en: 'job-details',
	'kl-gl': 'suliffeqarfik-nassuiaataa',
};
